import { SingleDatePicker } from "staysure-component-library";
import { LocaleType } from "staysure-component-library/dist/types/commonTypes";

import { useTravelDatesContext } from "@/app/components/travel-dates/providers/travel-dates.provider";
import { getDateLocaleCode } from "@/libs/i18n/config";
import { useWizardTranslation } from "@/libs/i18n/use-wizard-translation";
import { useCurrentLocale } from "@/libs/i18n/utils.client";

import { useDateSelectionAMT } from "./single-date-picker.hooks";

export default function SingleDatePickerComponent() {
  const context = useTravelDatesContext();
  const { handleDateSelectionAMT } = useDateSelectionAMT();
  const {
    cancelBtnClick,
    isDateError,
    isMobile,
    maxDateforAMT,
    travelDateErrorMessage,
    travelDates,
    setIsCalenderOpen,
  } = context;

  const locale = useCurrentLocale();
  const { t } = useWizardTranslation();

  return (
    <div>
      <SingleDatePicker
        maximumDate={maxDateforAMT}
        defaultDate={travelDates.startDate ?? undefined}
        onChange={(date: unknown) => handleDateSelectionAMT(date as Date)}
        isError={isDateError}
        customizedMessage={travelDateErrorMessage}
        disablePastDates
        isDateClear={cancelBtnClick}
        onCalenderViewUpdate={setIsCalenderOpen}
        isReadOnly={isMobile}
        isMobile={isMobile}
        locale={getDateLocaleCode(locale) as LocaleType}
        label={t("from", "From")}
      />
    </div>
  );
}
